<template>
    <div>
        <div class="page-content wrapper">
            <h1 class="page-title">{{ content.title }}</h1>
            <div v-html="content.body"></div>
        </div>
        
        <div class="sticky-footer">
            <button class="btn center noselect" @click="animateOut">Back</button>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import { gsap } from '/src/assets/js/gsap';
    import { ScrollToPlugin } from '/src/assets/js/gsap/ScrollToPlugin';

    export default {
        name : "InvestigationItem",
        mounted(){
            console.log( this.path )
            gsap.registerPlugin( ScrollToPlugin )
            this.$parent.appHeight()
            const tl = new gsap.timeline();
            tl.to( window, { duration : 0.5, scrollTo : 0, delay : .2, ease : "sine.out" });
            tl.from('h1, h3, img, p, li, button', {autoAlpha: 0, x: "-200px", stagger: { amount: 0.5}, ease: "sine.out"}, "+=0.25");
        },
        computed : {
            ...mapGetters([
                'getInvestigationBySlug'
            ]),
            params(){
                return this.$router.currentRoute.params
            },
            content(){
                const { action, item } = this.params
                const out = this.getInvestigationBySlug( action, item )
                console.log( out )
                return out
            }
        },
        methods: {
            animateOut() {
                gsap.to('h1, h3, img, p, li, button', {autoAlpha: 0, stagger: { amount: 0.35}, ease: "sine.in"});
                gsap.delayedCall(1, this.next);
            },
            next() {
                this.$router.push({ path: "/sim" });
            }
        },
    }
</script>